<template>
<div class="table-container" id="searchTable-container">

  <div class="table-header" id="searchTable-header">
    <div class="container-fluid almost-fluid" id="searchTable-container-fluid">
      <table class="table" id="searchTable">
        <caption class="accessibly-hidden">{{ 'CASES' | translate }} table header</caption>
        <thead id="searchTable-tableHead">
          <tr id="searchTable-tableRow">
            <th scope="col" id="searchTable-ID">{{ 'ID' | translate }}</th>
            <th scope="col" id="searchTable-POLICY_ID">{{ 'POLICY_ID' | translate }}</th>
            <th scope="col" id="searchTable-RELATION_ID">{{ 'RELATION_ID' | translate }}</th>
            <th scope="col" id="searchTable-PRODUCT_LINE">{{ 'PRODUCT_LINE' | translate }}</th>
            <th scope="col" id="searchTable-STATUS">{{ 'STATUS' | translate }}</th>
            <th scope="col" id="searchTable-BATCH">{{ 'BATCH' | translate }}</th>
            <th scope="col" id="searchTable-COVERS">{{ 'COVERS' | translate }}</th>
            <th scope="col" id="searchTable-CURRENT">{{ 'CURRENT' | translate }}</th>
            <th scope="col" id="searchTable-TOP_2">{{ 'TOP_2' | translate }}</th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
  
  <div class="table-body" id="searchTable-tableBody">
    <div class="container-fluid almost-fluid" id="searchTable-tableBody-container">
      <table class="table table-hover" id="searchTable-body">
        <caption class="accessibly-hidden">{{ 'CASES' | translate }}</caption>
        <thead class="d-none" id="searchTable-body-head"><tr><th scope="col"></th></tr></thead> <!-- sonar accesibility rules require a th element -->
        <tbody id="searchTable-tbody">
          <search-table-row v-for="row in caseList"
                            :key="row.policycaseHeaderId"
                            :caseObj="row" :insurers="insurers" :productLines="productLines"
                            :id="'searchTable-'+row.policycaseHeaderId">
          </search-table-row>
          <tr v-if="caseList.length < 1">
            <td colspan="9" class="text-center" :id="'searchTable-tData'">{{ 'msg.LIST_CASES_EMPTY' | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
</template>

<script>
import SearchTableRow from '@/components/cases/SearchTableRow';

export default {
  components: { SearchTableRow },
  props: ['caseList', 'insurers', 'productLines']
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/search-table";
</style>



// WEBPACK FOOTER //
// src/components/cases/SearchTable.vue